import './LlmHome.scss';

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import React from 'react'
import { Col, Container, Nav, Row } from 'react-bootstrap'
import { Outlet } from 'react-router-dom'
import { NavigationLink, SidebarLink } from '../../components/layout/AppSidebar';

const llmLinks: NavigationLink[] = [
  { key: 'rags', title: 'Rags', url: '/llm/rags', icon: solid('brain') },
  { key: 'loaders', title: 'Loaders', url: '/llm/loaders', icon: solid('bars-progress') },
  { key: 'models', title: 'Models', url: '/llm/models', icon: solid('microchip') },
]

export default function LlmHome() {
  return (
    <Container className="llm-container" fluid>
      <Row>
        <Col className="llm-sidebar-container">
          <Nav className="llm-sidebar border shadow-sm">
            {llmLinks.map(link => (
              <SidebarLink key={link.key} link={link} iconSize="lg" vertical />
            ))}
          </Nav>
        </Col>
        <Col>
          <Outlet />
        </Col>
      </Row>
    </Container>
  )
}